import React from 'react';

export default function () {
  const html = (props) => {
    const needs = props.field.config.needs;
    const latestProps = React.useRef(props);
    latestProps.current = props;

    React.useEffect(
      () => {
        const { globalState, field } = latestProps.current;
        let result = field.config.defaultValue ?? '';
        needs.forEach((need) => {
          if (globalState[need.field]?.includes(need.comparison)) {
            result = need.output;
          }
        });
        field.state.value = result;
        latestProps.current.onUpdate();
      },
      needs.map((need) => props.globalState[need.field])
    );

    return null;
  };

  return {
    html: html,
    config: { invisible: true },
  };
}
